// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ex5qk","placeholdersHeader":"styles_placeholdersHeader__3d_v8","editorStyle":"styles_editorStyle__1kmv7","placeholdersBox":"styles_placeholdersBox__3Lkkl"};